import { ActionService } from 'dashboard-services/services';

export const statusesActions = (() => {
  const CATEGORIES = {
    PIPELINES: "PIPELINE",
    GROUPS: "ETL",
  }

  const SELECTORS = {
    WARNING: "onlyWarn",
    ERROR: "onlyError",
    RUNNING: "onlyRunning",
    PAUSE: "onlyPaused"
  }

  const CHANGE_VALUE = 'CHANGE_VALUE_STATUSES'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const CLEAR = 'CLEAR_STATUSES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const ADD_TO_HISTORY = 'ADD_TO_HISTORY_STATUSES'
  const addToHistory = ActionService.makeActionCreator(ADD_TO_HISTORY)

  const BACK = 'BACK_STATUSES'
  const back = ActionService.makeActionCreator(BACK)

  const MODES = {
    MAIN: "MAIN",
    DETAILS: "DETAILS",
    HISTORY: "HISTORY",
    SEE_ALL: "SEE_ALL"
  }

  const getNonETLId = (payload, componentStatuses) => payload?.pipelineId || (payload?.dataprepId || componentStatuses?.find(componentStatuses => componentStatuses.component === "dataprep")?.payload?.dataprepId) || payload?.id

  return {
    ADD_TO_HISTORY,
    CATEGORIES,
    addToHistory,
    back,
    BACK,
    CHANGE_VALUE,
    changeValue,
    clear,
    CLEAR,
    getNonETLId,
    MODES,
    SELECTORS
  }
})()